module.exports = __webpack_public_path__ + "static/media/20190906_184023.3acebe0d.jpg";